export default {
    celular(value) {
        if (value) {
            return value.replace(/^\d{11}$/g, function (str) {
                return `(${str.substring(0, 2)}) ${str.substring(2, 7)}-${str.substring(7, 11)}`
            })
        }
    },
    cep(value) {
        if (value) {
            return value.replace(/^\d{8}$/g, function (str) {
                return `${str.substring(0, 2)}.${str.substring(2, 5)}-${str.substring(5, 8)}`
            })
        }
    },
    certidao(value) {
        if (value) {
            return value.replace(/^\d{32}$/g, function (str) {
                return `
                    ${str.substring(0, 6)}
                    ${str.substring(6, 8)}
                    ${str.substring(8, 10)}
                    ${str.substring(10, 14)}
                    ${str.substring(14, 15)}
                    ${str.substring(15, 20)}
                    ${str.substring(20, 23)}
                    ${str.substring(23, 30)}
                    ${str.substring(30, 32)}
                `
            })
        }
    },
    cpf(value) {
        if (value) {
            return value.replace(/^\d{11}$/g, function (str) {
                return `${str.substring(0, 3)}.${str.substring(3, 6)}.${str.substring(6, 9)}-${str.substring(9, 11)}`
            })
        }
    },
    telefone(value) {
        if (value) {
            return value.replace(/^\d{10}$/g, function (str) {
                return `(${str.substring(0, 2)}) ${str.substring(2, 6)}-${str.substring(6, 10)}`
            })
        }
    },
}